import React, { useEffect, useState } from 'react'
import { VirtualizedSelectOption, VirtualizedSelectOptionsType } from '../Select/SelectVirtualized';
import VirtualizedSelect from '../Select/SelectVirtualized';
import { nanoid } from 'nanoid';
import { useIntl } from 'react-intl';
import { SimpleMerchant } from '../../interfaces/Merchant';
import { SimpleMeeting } from '../../interfaces/Meeting';
import { SimplePipeline } from '../../interfaces/Pipeline';
import { User } from '../../interfaces/User';
import { getSelectedValueCustomFieldMeeting, getSelectedValueCustomFieldMerchant, getSelectedValueCustomFieldPipeline } from '../../functions/helperCustomField';
import { CustomField } from '../../interfaces/Settings';
import RenderMenuList from '../RenderComponent/RenderMenuList';
import { CustomSelectMeetingOption, CustomSelectPipelineOption, CustomSelectPipelineSingleValue } from '../Pipelines/CustomComponentSelect/CustomSelect';

interface ItemSelectValueCustomFieldProps {
    valueSelectOptionCustomField?: {
        pipeline?: SimplePipeline[]
        meeting?: SimpleMeeting[]
        merchant?: SimpleMerchant[]
        user?: User[]
        defaultMerchant?: SimpleMerchant[]
    }
    source: 'template-merchant' | 'template-user' | 'template-pipeline' | 'template-unit' | 'template-product',
    customFieldGeneral: CustomField
    activeTab: string
    placeholder: string
    isRequired?: boolean 
    typeMultiValue?: 'default' | 'meeting' | 'pipeline'
    valuesKey?: string[]
    onSelectedOptionsChange?: (customFieldId: string, options: string[]) => void
}

const ItemSelectValueCustomField = ({
    valueSelectOptionCustomField,
    source,
    customFieldGeneral,
    activeTab,
    placeholder,
    isRequired = false,
    valuesKey = [],
    typeMultiValue = 'default',
    onSelectedOptionsChange
}: ItemSelectValueCustomFieldProps) => {
    const intl = useIntl();
    const [options, setOptions] = useState<VirtualizedSelectOptionsType[]>([]);
    const [currentComponent, setCurrentComponent] = useState<any>(null);

    useEffect(() => {
        if (valueSelectOptionCustomField) {
            if (activeTab === 'originalMerchant' && valueSelectOptionCustomField.defaultMerchant) {
                const optionDefaultMerchantSimpleMerchant = valueSelectOptionCustomField.defaultMerchant.map((option: SimpleMerchant) => ({
                    ...option,
                    value: option.id,
                    label: option.name!
                }));
                setOptions(optionDefaultMerchantSimpleMerchant || []);
                setCurrentComponent(getMenuList('originalMerchant', 'merchant'));
            }

            Object.keys(customFieldGeneral).forEach((key) => {
                if (customFieldGeneral[key].type === 'pipeline' && activeTab === key && valueSelectOptionCustomField.pipeline) {
                    const optionsSimplePipeline = valueSelectOptionCustomField.pipeline.map((option: SimplePipeline) => ({
                        ...option,
                        value: option.id,
                        label: option.name!
                    }));
                    setOptions(optionsSimplePipeline || []);
                    setCurrentComponent(getMenuList(key, 'pipeline'));
                } else if (customFieldGeneral[key].type === 'merchant' && activeTab === key && valueSelectOptionCustomField.merchant) {
                    const optionsSimpleMerchant = valueSelectOptionCustomField.merchant.map((option: SimpleMerchant) => ({
                        ...option,
                        value: option.id,
                        label: option.name!
                    }));
                    setOptions(optionsSimpleMerchant || []);
                    setCurrentComponent(getMenuList(key, 'merchant'));
                } else if (customFieldGeneral[key].type === 'meeting' && activeTab === key && valueSelectOptionCustomField.meeting) {
                    const optionsSimpleMeeting = valueSelectOptionCustomField.meeting.map((option: SimpleMeeting) => ({
                        ...option,
                        value: option.id,
                        label: option.name!
                    }));
                    setOptions(optionsSimpleMeeting || []);
                    setCurrentComponent(getMenuList(key, 'meeting'));
                } else if (customFieldGeneral[key].type === 'user' && activeTab === key && valueSelectOptionCustomField.user) {
                    const optionsSimpleUser = valueSelectOptionCustomField.user.map((option: User) => ({
                        ...option,
                        value: option.id,
                        label: option.name!
                    }));
                    setOptions(optionsSimpleUser || []);
                    setCurrentComponent(getMenuList(key, 'user'));
                }
            });
        }

    }, [valueSelectOptionCustomField, activeTab, customFieldGeneral]);

    useEffect(() => {
        setOptions([]);
    }, [activeTab]);

    const handleChangeSelectedOptions = (selectedOptions: VirtualizedSelectOption[]) => {
        if (onSelectedOptionsChange) {
            const optionValues = selectedOptions.map(option => option.value as string);
            onSelectedOptionsChange(activeTab, optionValues);
        }
    };

    const getMenuList = (key: string, type: string) => {
        if (type === 'pipeline') {
            return {
                Option: CustomSelectPipelineOption,
            };
        } else if (type === 'meeting') {
            return {
                Option: CustomSelectMeetingOption
            };
        } else {
            return {
                MenuList: RenderMenuList
            };
        }
    };

    return (
        <div className="input-group mb-3">
            <VirtualizedSelect
                // key={`${activeTab}-${nanoid()}`}
                options={options}
                isLoading={false}
                isDisabled={false}
                className="w-100"
                placeholder={placeholder}
                value={options.filter(option => valuesKey.includes(option.value as string)) as VirtualizedSelectOption[]}
                onChange={handleChangeSelectedOptions}
                components={{
                    Option: currentComponent?.Option,
                }}
                typeMultiValue={typeMultiValue}
                isMultiValue
                isMulti
            />
        </div>
    );
};

export default ItemSelectValueCustomField;